if (typeof DynaBase_Url == 'undefined')
{
    var DynaBase_Url =
    {
        /**
         * Get part of current url
         */
        getPart: function(index)
        {
            var pathArray = window.location.pathname.split('/');

            return pathArray[index+1];
        }
    }
}
